import React, { useState, useRef, useMemo, useEffect } from 'react'
import { Model } from 'survey-core'
import { Survey } from 'survey-react-ui'
// import 'survey-core/defaultV2.min.css'

import { useConvertSurvey } from '../hooks/useConvertSurvey'
import { useSubmitAnswers } from '../hooks/useSubmitAnswers'
import 'survey-core/i18n/traditional-chinese'

const Agree = ({
  setAc,
  setTk,
  ac,
  tk,
  pid,
  setIsLoading,
  setCompletionMessage,
}) => {
  const [myAgreeJson, setMyAgreeJson] = useState(null)
  // 需要登入嗎
  const requiresLogin = {
    login: false,
    title: '員工編號（邁達特：MA、啟迪：GI、聚上雲：EP、逐鹿：GU）',
    placeholder: 'MA00000',
    alert: '員工編號有誤，請重新登入，謝謝',
  }
  const [imagesReadingTime, setImagesReadingTime] = useState(0)
  const canShowPrevButtonPages = null
  const choicesOrderRef = useRef({})
  const choiceIndexMapRef = useRef({})
  const bringOptionsMapRef = useRef({})
  // 圖片閱讀時間(秒)
  // useEffect(() => {
  //   setImagesReadingTime(30)
  // }, [])
  const completedHtml = `<h3>問卷正在提交中，請稍候。</h3><h3>請在成功頁面顯示後再離開。</h3><h4>如有填卷相關問題請洽：</h4> <a href='https://lin.ee/HWETcqy'>https://lin.ee/HWETcqy</a><h4 style='margin-top:50px'>填寫其他問卷：</h4> <a href=${window.location.origin}>${window.location.origin}</a>`

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const agreeSurvey = new Model(myAgreeJson)

  // 問卷編號
  // const pid = pid
  // 跳題 小心複選題要用陣列

  // const visibleIfConditionsInit = {
  //   q6: '{q5} = 0 or {q5} = 1 or {q5} = 2 or {q5} = 3',
  //   q7: '{q6} = ["none"]',
  //   q36: `{q35} <> ['none']`,
  // }

  const visibleIfConditionsInit = {
    q8: '{q7} <> ["none"]',
    q10: '{q9} = 0',
    q12: '{q11} = 0',
    q22: '{q21} = 0',
    q23: '{q22} = 3 or {q22} = 4',
    q25: '{q24} = 0',
    q26: '{q24} = 0',
    q27: '{q24} = 0 and {q26} = 0',
    q28: '{q24} = 0 and {q26} = 0',
    q29: '{q24} = 0 and {q26} = 0 and ({q28} = 0 or {q28} = 1)',
    q30: '{q24} = 0 and {q26} = 0 and ({q28} = 3 or {q28} = 4)',
    q31: '{q24} = 0 and {q26} = 0',
    q32: '{q24} = 1',
    q35: '{q34} = 0',
    q45: '{q44} = 0',
    q46: '{q44} = 0 and ({q45} = 3 or {q45} = 4)',
    q48: '{q47} = 0',
    q49: '{q47} = 0',
    q50: '{q47} = 0 and {q49} = 0',
    q51: '{q47} = 0 and {q49} = 0',
    q52: '{q51} = 0 or {q51} = 1',
    q53: '{q47} = 0 and {q49} = 0 and ({q51} = 3 or {q51} = 4)',
    q54: '{q47} = 0 and {q49} = 0',
    q55: '{q47} = 1',
  }
  // const visibleIfConditionsInit = null
  // const pageVisibleIfConditionsInit = null

  // 非必填(從 0 計算)
  // const notRequired = [100]
  const notRequired = null

  const mappedRateChoice = null
  // const pageBreakQuestions = ['q6', 'q11', 'q15']
  const pageBreakQuestions = null

  const triggersConditionsInit = [
    {
      type: 'complete',
      expression: `({q0} = 1) or ({q7} = ['none'])`,
    },
  ]
  // const triggersConditionsInit = null
  // const pageVisibleIfConditionsInit = null

  const convertedSurvey = useConvertSurvey({
    survey: agreeSurvey,
    pid,
    setAc,
    setTk,
    ac,
    tk,
    setMyAgreeJson,
    imagesReadingTime,
    setImagesReadingTime,
    setIsLoading,
    completedHtml,
    visibleIfConditionsInit,
    notRequired,
    mappedRateChoice,
    pageBreakQuestions,
    requiresLogin,
    triggersConditionsInit,
    bringOptionsMapRef,
  })

  // const newSurvey = new Model(convertedSurvey)

  const surveyModel = useMemo(() => {
    if (!convertedSurvey) return null
    return new Model(convertedSurvey)
  }, [convertedSurvey])

  // useEffect(() => {
  //   console.log('convertedSurvey', convertedSurvey)
  // }, [convertedSurvey])

  const endMessage = `很抱歉，目前與您相同特性的樣本已經額滿，沒辦法參與本次活動。歡迎您分享本問卷連結給其他親朋好友，或加入我們的<a href='https://lin.ee/HWETcqy'>LINE@</a>，隨時得到最新填問卷獲好禮的消息。<p>請按「完成」前往下載 EZChoice 或填寫更多問卷</p>`

  // 帶入選項
  // 帶入帶出參考
  // 帶出: 帶入
  const questionMappings = {
    q7: 'q8',
  }

  function helpFunction(survey, options) {
    // console.log('survey.getValue(q42)', survey.getValue('q7'))
    // 參考 P231113152849 或 P231101165555 或 P231206105643(政大帶入選項)
    if (questionMappings.hasOwnProperty(options.name)) {
      // 篩選變下一題的選項

      const targetQuestionName = questionMappings[options.name]
      const targetQuestion = survey.getQuestionByName(targetQuestionName)
      const sourceQuestion = survey.getQuestionByName(options.name)
      let choices = []

      if (options.value) {
        options.value.forEach(function (choiceValue, index) {
          if (typeof choiceValue === 'number') {
            const foundChoice = sourceQuestion.choices.find(
              (choice) => choice.value === choiceValue
            )

            const choiceText = foundChoice ? foundChoice.text : choiceValue
            choices.push({ value: index, text: choiceText })
          } else if (choiceValue === 'other') {
            choices.push({
              value: index,
              text: '其他(上題填寫內容)',
            })
          } else if (choiceValue === 'none') {
            choices.push({
              value: index,
              text: options.question.noneText,
            })
          }
        })
      }

      targetQuestion.choices = choices
      // 最後回傳的 order 要改
      const order = targetQuestion.visibleChoices
      if (order) {
        // 將選項順序設為每個選項的索引值
        choiceIndexMapRef.current[targetQuestionName] = order.reduce(
          (map, choice, index) => {
            map[index] = { index: index, title: choice.title }
            return map
          },
          {}
        )
        console.log('choiceIndexMapRef', choiceIndexMapRef)
      }
    }
  }

  const endSurveyMsg = (survey) => {
    if (survey.getValue('q0') === 1 || survey.getValue('q7')[0] === 'none') {
      setCompletionMessage(endMessage)
    } else {
      setCompletionMessage(
        `<h4 style='text-align: center'>問卷已成功送出</h4><h4 style='text-align: center'>請按「完成」前往下載 EZChoice 或填寫更多問卷</h4>`
      )
    }
  }

  // useEffect(() => {
  //   console.log('bringOptionsMapRef', bringOptionsMapRef)
  // }, [bringOptionsMapRef])

  useSubmitAnswers({
    survey: surveyModel,
    pid,
    ac,
    tk,
    imagesReadingTime,
    setIsLoading,
    helpFunction,
    canShowPrevButtonPages,
    choicesOrderRef,
    choiceIndexMapRef,
    endSurveyMsg,
    bringOptionsMapRef,
  })

  return (
    <>
      {surveyModel ? (
        <Survey model={surveyModel} key={pid} />
      ) : myAgreeJson ? (
        <Survey model={agreeSurvey} />
      ) : (
        <></>
      )}
    </>
  )
}

export default Agree
